class Utils {
    constructor() {
        this.shortDateFormat = "MM/DD";
        this.selectDropdownloIntervalValuesForThreeMonth = [
            {displayText: 'Select Interval', value: 30},
            {displayText: 'One Month', value: 30},
            {displayText: 'Two Months', value: 60},
            {displayText: 'Three Months', value: 90}
        ];

        this.selectDropdownloIntervalValuesForInactiveAccounts = [
            {displayText: 'Select Interval', value: 180},
            {displayText: 'Three Month', value: 90},
            {displayText: 'Six Months', value: 180},
            {displayText: 'Nine Months', value: 270}
        ];

        this.statusDropdownOptions = [
            {displayText: 'Any status', value: ""},
            {displayText: 'Active', value: "active"},
            {displayText: 'Disabled', value: "disabled"},
            {displayText: 'Inactive', value: "inactive"}
        ];

        this.languagePreferenceDropdownOptions = [
            {displayText: 'Any Language', value: ""},
            {displayText: 'English', value: "en"},
            {displayText: 'Arabic', value: "ar"},
        ];

        this.withOrWithoutShipmentsDropdownOptions = [
            {displayText: 'Any Shipments', value: ""},
            {displayText: 'With Sent Shipments', value: "withSentShipments"},
            {displayText: 'Without Sent Shipments', value: "withoutSentShipments"}
        ];

        this.packageStatusDropdownOptions = [
            {displayText: 'Any status', value: ""},
            {displayText: 'Draft', value: "draft"},
            {displayText: 'Checked In', value: "checked-in"},
            {displayText: 'Pending Special Request', value: "pending-request"},
            {displayText: 'Picked', value: "picked"},
            {displayText: 'Shipped', value: "shipped"},
            {displayText: 'Duplicate', value: "duplicate"},
            {displayText: 'Pending Disposal', value: "pending-disposal"},
            {displayText: 'Disposed', value: "disposed"},
            {displayText: 'Disposed-Error', value: "disposed-error"},
            {displayText: 'Disposed-Returned', value: "disposed-returned"}
        ];

        this.packageTypeDropdownOptions = [
            {displayText: 'Any Type', value: ""},
            {displayText: 'Incoming', value: "1"},
            {displayText: 'Consolidated', value: "2"},
            {displayText: 'Problem', value: "3"}
        ];

        this.shipmentStatusDropdownOptions = [
            {displayText: 'Any status', value: ""},
            {displayText: 'Cancelled', value: "cancelled"},
            {displayText: 'Cancelled Delivered', value: "cancelled-delivered"},
            {displayText: 'Draft', value: "draft"},
            {displayText: 'Consolidation Requested', value: "consolidation-requested"},
            {displayText: 'Shipping Requested', value: "shipping-requested"},
            {displayText: 'Consolidation Completed', value: "consolidation-completed"},
            {displayText: 'Hold For Payment', value: "hold-for-payment"},
            {displayText: 'Freight Consolidation Requested', value: "freight-consolidation-requested"},
            {displayText: 'Freight Consolidation in Progress', value: "freight-consolidation-in-progress"},
            {displayText: 'Freight Pending Shipment', value: "freight-pending-shipment"},
            {displayText: 'Pending Shipment', value: "pending-shipment"},
            {displayText: 'Pending Shipment Error', value: "pending-shipment-error"},
            {displayText: 'Shipped Pending Delivery', value: "shipped-pending-delivery"},
            {displayText: 'Delivery Confirmation Expired', value: "delivery-confirmation-expired"},
            {displayText: 'Shipped And Delivered', value: "shipped-and-delivered"},
            {displayText: 'Pending Return', value: "pending-return"},
            {displayText: 'Returned Pending Delivery', value: "returned-pending-delivery"},
            {displayText: 'Payment Review', value: "payment-review"},
            {displayText: 'Hazmat Review', value: "hazmat-review"},
            {displayText: 'Claim Pending', value: "claim-pending"},
            {displayText: 'Claim Resolved', value: "claim-resolved"}
        ];

        this.groupByOptions = [
            {displayText: 'Any Group', value: ""},
            {displayText: 'Group By Created Date', value: "groupByDate"},
            {displayText: 'Group By Account ID', value: "groupByAccountId"}
        ];

        this.couponStatusDropdownOptions = [
            {displayText: 'Any status', value: ""},
            {displayText: 'Active', value: "active"},
            {displayText: 'Disabled', value: "disabled"}
        ];

        this.intervalOptions = [
            {displayText: 'Select Interval', value: 60},
            {displayText: 'One Month', value: 30},
            {displayText: 'Two Months', value: 60},
            {displayText: 'Three Months', value: 90}
        ];

        this.intervalOptionsByMonth = [
            {displayText: 'Select Interval', value: 366},
            {displayText: 'One Year', value: 366}
        ]
    }

} export default new Utils();
